export default {
    workOrder_comments_createSuccessMessages: "Comment saved",
    workOrder_comments_deleteSuccessMessages: "Comment deleted",
    workOrder_comments_send: "Save",
    workOrder_comments_placeholder: "Add a comment...",
    workOrder_comments_errorUpdateComment: "It is not possible to edit or delete this comment",
    workOrder_comments_createBy: "Created By",
    workOrder_comments_createOn: "Created On",
    workOrder_comments_comment: "Comment",
};